import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { primaryColors, vestaGradient } from './styles/colors';

const MuiSlider: Components<Omit<Theme, 'components'>>['MuiSlider'] = {
  styleOverrides: {
    root: {
      '.MuiSlider-rail': {
        background: primaryColors[100],
      },
      '.MuiSlider-track': {
        background: vestaGradient,
      },

      '.MuiSlider-thumb': {
        background: vestaGradient,
      },

      '.MuiSlider-thumb.Mui-active, .MuiSlider-thumb.Mui-focusVisible': {
        boxShadow: 'none',
      },
    },
    colorSecondary: {
      '.MuiSlider-track': {
        background: primaryColors[100],
        color: primaryColors[100],
      },
    },
  },
};

export default MuiSlider;
